import React, { useState } from "react";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import ReactCustomModal from "components/CustomModal/ReactCustomModal";

export default function JoinTeam({
  openRefreshModal,
  setOpenRefreshModal,
  closeRefreshModal,
}) {
  const [loading, setLoading] = useState(false);
  const confirmClick = () => {
    setLoading(true);
    setTimeout(() => {
      closeRefreshModal();
      setLoading(false);
    }, 200);
  };
  const onCloseModal = () => {
    closeRefreshModal();
  };
  return (
    <>
      <ReactCustomModal
        closeDialog={onCloseModal}
        modelOpen={openRefreshModal}
        modalHeaderClass={"assessmentRefreshModal"}
      >
        <div className={"assessmentRefreshRootContent"}>
          <div className="assessmentRefreshHeading">
            <h5>Refresh Confirmation</h5>
          </div>
          <div className="assessmentRefreshMainContent">
            Do you want to restart this assessment, kindly confirm.
          </div>
          <div className="assessmentRefreshAction">
            <Button
              name={!loading ? "Confirm" : <Loader width={25} height={25} />}
              buttonClass="btn"
              buttonStyle={{
                width: "130px",
                margin: "0 5px",
                color: "#fff",
                backgroundColor: "#FFA100",
              }}
              onClick={confirmClick}
            />
            <Button
              type="button"
              buttonClass="btn"
              buttonStyle={{
                width: "130px",
                margin: "0 5px",
                color: "#fff",
                backgroundColor: "#FFA100",
              }}
              name="Cancel"
              onClick={() => setOpenRefreshModal(false)}
            />
          </div>
        </div>
      </ReactCustomModal>
    </>
  );
}
